<template>
    <div>
        <BasicDialog @close="dialogClosed">
            <v-row>


                <v-col cols="12" class="d-flex flex-row justify-center align-center">
                    <logo-background></logo-background>
                    <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                        <img :src="AppConfigs.staticImages.VERIFYPHONENUMBERDIALOG" alt="Share on WhatsApp"
                            style="width: 70%; height: auto;">
                        <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable"
                            style="position: absolute; top: -25%; left: 5%;">
                    </div>
                </v-col>





                <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
                    Verify Your Referral Code
                </v-col>



                <v-col cols="12" class="text-center">
                    Earn {{ coinsForSubmittingReferralCode }} coins by verifying your
                    Referral Code
                </v-col>




                <v-col cols="12" class="text-center">


                    <span>Enter Referral Number</span>



                    <v-text-field v-model="referralCode" placeholfer="Enter Your Referral Code"
                        class="mt-1 mx-sm-16 px-sm-16" style="z-index: 1; position: relative;" bg-color="formBackground"
                        variant="solo" type="text" hide-details>
                    </v-text-field>


                </v-col>






                <v-col cols="12" class="d-flex flex-row justify-center">
                    <v-btn @click="submitReferralCode" :disabled="!isAvailable"
                        class="rounded-pill button--primary   text-body-2 font-weight-bold py-6 px-7 d-flex">
                        Submit
                    </v-btn>
                </v-col>


            </v-row>
        </BasicDialog>
    </div>
</template>



<script>


import { AppConfigs } from "@/app.configs";
import { useAuthStore } from '@/store/AuthStore';
import { useSnackbar } from '@/composables/useSnackbar';

import { inject, provide, ref, computed } from 'vue';
import LogoBackground from "@/icons/LogoBackground.vue";
import { UserActivityStore } from '@/store/UserActivityStore';
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import { watch, onMounted } from 'vue';


export default {
    name: 'SubmitReferralDialog',
    components: {
        BasicDialog,
        LogoBackground,
    },
    setup(props, { emit }) {
        const { showSnackbar } = useSnackbar();
        const referralCode = ref('');
        const authStore = useAuthStore();
        const inHouseTaskStore = UserActivityStore();

        const openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);

        const coinsForSubmittingReferralCode = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
        const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

        onMounted(() => {
            // This will check the referral code once the component has been mounted
            if (authStore.referralCode) {
                referralCode.value = authStore.referralCode;
            }
        });

        const dialogClosed = () => {
            emit('close');
        };


        const submitReferralCode = async () => {
            try {
                await inHouseTaskStore.redeemCoinsForSelectedInHouseTask({
                    referral_code: referralCode.value,
                });
                showSnackbar({
                    message: 'Referral Code Submitted Successfully',
                    color: 'success'
                });

                setTimeout(() => {
                    openDialog.value = false;
                }, 1000);
            }
            catch (error) {
                showSnackbar({
                    message: 'Invalid Referral Code',
                    color: 'error'
                });
            }
            finally {
                authStore.removeReferralCode();
            }
        };


        return {
            AppConfigs,
            isAvailable,
            dialogClosed,
            referralCode,
            submitReferralCode,
            coinsForSubmittingReferralCode,
        };

    }
};




</script>